import { ChipOption } from '@marageti/z4-lib';
import { TripMatchStatus, SalesStage } from '@marageti/z4-sdk/lib/travel';
import { canceledStatusesValue } from '../../hooks/use-trip-match-search';

type Option = {
  title: string;
  value: string;
};

export const sortByOptionsSoldTrips: Option[] = [
  { title: 'Return Date', value: 'returnDate' },
  { title: 'Match Date', value: 'createdAt' },
  { title: 'Total Trip Price', value: 'totalTripPrice' },
  { title: 'Departure Date (Upcoming)', value: 'departureDateUpcoming' },
  { title: 'Departure Date (Past)', value: 'departureDatePast' },
  { title: 'Departure Date (All)', value: 'departureDateAll' },
];

export const sortByOptionsAllTrips: Option[] = [
  { title: 'Match Date', value: 'createdAt' },
  { title: 'Total Budget', value: 'budget' },
  { title: 'Departure Date (New to Old)', value: 'departureDateDesc' },
  { title: 'Departure Date (Old to New)', value: 'departureDateAsc' },
];

export const sortByValuesSoldTrips: { [key: string]: { field: string; order: string } } = {
  returnDate: { field: 'returnDate', order: 'desc' },
  createdAt: { field: 'createdAt', order: 'desc' },
  totalTripPrice: { field: 'totalTripPrice.amountUSD', order: 'desc' },
  departureDateUpcoming: { field: 'departureDate', order: 'asc' },
  departureDatePast: { field: 'departureDate', order: 'desc' },
  departureDateAll: { field: 'departureDate', order: 'asc' },
};

export const sortByValuesAllTrips: { [key: string]: { field: string; order: string } } = {
  createdAt: { field: 'createdAt', order: 'desc' },
  budget: { field: 'budget', order: 'desc' },
  departureDateDesc: { field: 'departureDate', order: 'desc' },
  departureDateAsc: { field: 'departureDate', order: 'asc' },
};

export const statusChipOptions: ChipOption[] = [
  { key: 0, label: 'New', value: TripMatchStatus.MatchPending },
  { key: 1, label: 'Accepted', value: TripMatchStatus.MatchAccepted },
  { key: 2, label: 'Active', value: TripMatchStatus.MatchActive },
  { key: 3, label: 'Sold', value: TripMatchStatus.MatchSold },
  { key: 4, label: 'Partner Declined', value: TripMatchStatus.MatchPartnerDeclined },
  { key: 5, label: 'Postponed', value: TripMatchStatus.MatchPostponed },
  { key: 6, label: 'Inactive', value: TripMatchStatus.MatchInactive },
  { key: 7, label: 'Canceled', value: canceledStatusesValue },
];

export const salesStageChipOptions: ChipOption[] = [
  // { key: 0, label: 'Needs Follow Up', value: SalesStage.NeedsFollowUp }, // TODO: Deprecate
  // { key: 1, label: 'Proposal', value: SalesStage.NeedsProposal }, // TODO: Deprecate
  // { key: 2, label: 'Proposal Sent', value: SalesStage.ProposalSent }, // TODO: Deprecate
  { key: 0, label: 'First Message', value: SalesStage.FirstMessageSent },
  { key: 1, label: 'Consultation', value: SalesStage.Consultation },
  { key: 2, label: 'Proposal Sent', value: SalesStage.ItinerarySent },
  { key: 3, label: 'Itinerary Review', value: SalesStage.ItineraryInReview },
];

export const refineSoldChipOptions: ChipOption[] = [
  { key: 0, label: 'Pre Travel', value: 'preTravel' },
  { key: 1, label: 'In Country', value: 'inCountry' },
  { key: 2, label: 'Request Review', value: 'requestReview' },
  { key: 3, label: 'Waiting for Review', value: 'waitingForReview' },
];
